/* eslint-disable @typescript-eslint/typedef */

import { importProvidersFrom, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Routes } from '@angular/router';
import {
  ContextComponent, ContextGuard, LogoutComponent, NgxGdlWwwModule, NotFoundComponent, RedirectComponent,
  RouteConstants, SecureComponent, UnAuthorizedComponent
} from '@krysgroup/ngx-application';

const canActivateContext: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(ContextGuard).canActivate(route, state);
  };
export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `/${RouteConstants.REDIRECT}`
  },
  {
    path: RouteConstants.CONTEXT,
    component: ContextComponent,
  },
  {
    path: RouteConstants.NOTFOUND,
    component: NotFoundComponent
  },
  {
    path: RouteConstants.UNAUTHORIZED,
    component: UnAuthorizedComponent
  },
  {
    // Utilisé pour ne pas declancher le lazy-loading de Secure sur le pathMatch: 'full'
    path: RouteConstants.REDIRECT,
    component: RedirectComponent,
    canActivate: [canActivateContext]
  },
  {
    path: RouteConstants.LOGOUT,
    component: LogoutComponent
  },
  {
    path: RouteConstants.SECURE,
    component: SecureComponent,
    canActivate: [canActivateContext],
    providers: [importProvidersFrom(NgxGdlWwwModule)],
    loadChildren: () => import('./www/www.route').then(mod => mod.wwwRoutes)
  },
  // 404 page
  { path: '**', component: NotFoundComponent }
];
